export enum AccountType {
  Person = 'person',
}
